export enum EToastType {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
